const eventsEn = {
    "events_title": "Events",
    "add_event": "Add Event",
    "event_id": "Event ID",
    "event_name": "Event Name",
    "event_description": "Event Description",
    "event_start_date": "Event Start Date",
    "event_end_date": "Event End Date",
    "event_reservations": "Reservations",
    "event_reservations_limit": "Available Spots (people)",
    "reservations_guest_count": "Reservation (people)",
    "event_delete": "Delete Event",
    "event_delete_confirmation": "Are you sure you want to delete this event?",
    "events": "Events",
    "reservation_limit": "Reservation Limit",
    "event_id_placeholder": "e.g., wine-tasting-2025",
    "event_name_placeholder": "e.g., Wine Tasting 2025",
    "event_description_placeholder": "Short description of the event",
    "event_reservations_limit_placeholder": "e.g., 10",
    "delete_event": "Delete Event",
    "event_created": "Event successfully created",
    "event_deleted": "Event successfully deleted",
    "event_url": "External URL",
    "event_url_placeholder": "e.g.: https://tixa.hu/myevent",
    "url_description": "If an URL is provided, clicking the event will redirect the guest to the link. Reservations cannot be made for this event within the system.",
    "event_start_time": "Event Start Time",
    "event_end_time": "Event End Time",
    "edit_event": "Edit Event",
    "save_event": "Save Event",
    "event_updated": "Event successfully updated",
    "event_selector_tabs": {
        "future": "Upcoming events",
        "past": "Past events",
    },
    "event_selector_title": "Select Event",
    "no_event_available": "Nincs elérhető esemény",
    "event_image": "Event background image",
    "delete_image": "Delete Image",
    "image_delete_confirm": "Are you sure you want to delete the event image from storage?",
    "image_deleted": "Image successfully deleted",
    "private_event": "Private event",
    "private_event_description": "Private events are not shown on the public listing page. They are only accessible via a direct link or a group link.",
    "event_group_id": "Group identifier",
    "event_group_id_placeholder": "e.g. corinthia-hotel-guests",
    "event_group_id_description": "If filled, the event appears on the group page: reservours.com/en/events/{group_id}. Leave empty to make the event accessible via direct link only.",
    "event_group_link": "Group link",
    "booking_closed": "Booking closed",
    "booking_closed_description": "If checked, the event is not visible anywhere and cannot be booked.",
    "generate_group_id": "Generate",
    "reset_event_id": "Reset to auto-generated",
    "copy_event": "Copy event",
    "event_name_en": "Event Name (English)",
    "event_name_en_placeholder": "e.g. Summer Party 2025",
    "event_description_en": "Event Description (English)",
}

export default eventsEn;